module.exports = __webpack_public_path__ + "static/NeueMontreal-Medium-2707e1302e24107b0e53477cbbc4d3c9.woff";